import { Component, DestroyRef, inject, type OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { injectQueryParams } from 'ngxtension/inject-query-params';

import { AuthenticationService } from '@app/auth/services/authentication.service';
import { AppConfigService } from '@app/shared/services/app-config.service';
import { WindowService } from '@app/shared/services/window.service';

@Component({
    selector: 'cor-logout',
    templateUrl: './logout.component.html',
    imports: [RouterModule],
})
export class LogoutComponent implements OnInit {
    private readonly returnUrl = injectQueryParams('returnUrl');

    private readonly appConfig = inject(AppConfigService).appConfig;

    private readonly authService = inject(AuthenticationService);
    private readonly windowService = inject(WindowService);
    private readonly destroyRef = inject(DestroyRef);

    protected showMessage = false;

    ngOnInit(): void {
        const returnUrl = this.returnUrl() || '';

        let redirectUrl: string;

        const url = new URL(`${this.appConfig().backendUrl}/login`, window.location.origin);
        if (returnUrl) {
            url.searchParams.set('returnUrl', returnUrl);
        }
        redirectUrl = url.toString();

        this.authService
            .logout(returnUrl)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                if (redirectUrl) {
                    // When logging out, we use window.location.href to hard-refresh the page and fetch the
                    // latest application. We avoid using the angular routing as that will not refresh the
                    // angular code in the browser (in case it has changed)
                    this.windowService.replaceUrl(redirectUrl);
                }
            });
    }
}
